import Icons from './icons';
import { IconName } from './types';

export default function getIconSVG(name: IconName) {
  const svgIcon = Object.entries(Icons).find(([key, _value]) => key === name);
  return svgIcon ? svgIcon[1] : null;
}
